/**
 * Copies query parameters from one URL to another.
 *
 * @param toUrl - Target URL to add parameters to
 * @param fromUrl - Source URL to copy parameters from (default: window.location.href)
 * @param keys - Specific keys to copy (default: all keys)
 * @returns Modified URL with copied parameters
 * @example extendUrlParams('https://example.com', window.location.href, ['utm_source'])
 */
function extendUrlParams(
  toUrl: string,
  fromUrl = window.location.href,
  keys?: string[],
) {
  const toUrlUrl = new URL(toUrl);
  const fromSearchParams = new URL(fromUrl).searchParams;

  (keys ?? [...fromSearchParams.keys()]).forEach((key) => {
    const value = fromSearchParams.get(key);
    if (value) {
      toUrlUrl.searchParams.set(key, value);
    }
  });

  return toUrlUrl.href;
}

export { extendUrlParams };
